import { Icon, IconButton, TextEllipsis } from '@aibees/shared/components';
import { classnames } from '@aibees/shared/utils';
import { Avatar, Stack } from '@mui/material';
import { memo } from 'react';
import { getContactDetailsCompanyLink } from '../../../contact-details/utils';
import { ProfilePositionItem } from '../profile-position-item';
import * as Styled from './styles';
import * as SX from './sx';
import type { ProfileRolesItemProps as Props } from './types';
import { getPathWithId } from '@aibees/elephant/utils';
import { ROUTES } from '@aibees/elephant/router';

export const ProfileRolesItem = memo(
  ({ className, companyData, isMainPage }: Props) => {
    const handleNavigateToCompanyPage = () => {
      if (companyData?.company?.id) {
        const companyPageUrl = getPathWithId(
          ROUTES.company,
          companyData.company.id
        );
        window.open(companyPageUrl, '_blank');
      }
    };

    return (
      <Styled.Wrapper
        className={classnames('ProfileRolesItem', className)}
        sx={SX.root(isMainPage)}
        direction="column"
        gap={1}
      >
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
        >
          <Stack
            direction="row"
            alignItems="center"
            gap={0.5}
            overflow="hidden"
          >
            <Avatar
              src={companyData?.company?.logo ?? undefined}
              variant="rounded"
              size={24}
              color="white"
            >
              <Icon size={20} name={'business'} color="grey.400" />
            </Avatar>

            <Styled.Link
              to={getContactDetailsCompanyLink(companyData?.company)}
            >
              <TextEllipsis
                variant="body4"
                color="grey.700"
                fontWeight={700}
                sx={SX.companyName}
              >
                {companyData?.company?.name}
              </TextEllipsis>
            </Styled.Link>
          </Stack>

          <IconButton
            icon="link-out"
            onClick={handleNavigateToCompanyPage}
            size="xsmall"
            variant="text"
            color="default"
            iconSize={12}
          />
        </Stack>

        {companyData.profile_positions?.map((position, index) => (
          <ProfilePositionItem
            key={index}
            position={position}
            isLast={index === (companyData.profile_positions?.length || 0) - 1}
          />
        ))}
      </Styled.Wrapper>
    );
  }
);

ProfileRolesItem.displayName = 'ProfileRolesItem';
